<a *ngIf="row.get('duplicateIds')?.length > 0" 
    [routerLink]="['/pub/' + row.get('Publication.id') + '/duplicatessearchresult']"
    [queryParams]="createDuplicatesQueryParams(row)"
    hisImage="publication_duplicate" class="inlineicon"
    [title]="'cs.sys.duplicates.check.viewDuplicates' | hisUi: row.get('Publication.title')"
    (click)="onBeforeNavigate()"></a>
<img *ngIf="!row.get('duplicateIds') || row.get('duplicateIds').length < 1"
    hisImage="publication_duplicate_i" class="inlineicon imggrey"
    [title]="'cs.sys.duplicates.check.noDuplicates' | hisUi">
